export default "__VITE_ASSET__3mq8JcJW__"